import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Loader2, CheckCircle, XCircle, BellOff } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function HROptOutPage() {
  const { token } = useParams();
  const [status, setStatus] = useState('loading'); // loading, success, error
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    processOptOut();
  }, [token]);

  const processOptOut = async () => {
    try {
      const response = await fetch(`${API_URL}/api/hr-pipeline/opt-out/${token}`);
      const data = await response.json();
      
      if (response.ok) {
        setResult(data);
        setStatus('success');
      } else {
        setError(data.detail || 'Invalid or expired opt-out link');
        setStatus('error');
      }
    } catch (err) {
      setError('Failed to process request');
      setStatus('error');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center p-4">
      <Card className="max-w-md w-full shadow-xl">
        <CardContent className="p-8 text-center">
          {status === 'loading' && (
            <>
              <Loader2 className="w-12 h-12 animate-spin text-slate-400 mx-auto mb-4" />
              <p className="text-slate-600">Processing your request...</p>
            </>
          )}
          
          {status === 'success' && (
            <>
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <BellOff className="w-8 h-8 text-green-600" />
              </div>
              <h1 className="text-2xl font-bold text-slate-800 mb-2">Reminders Stopped</h1>
              <p className="text-slate-600 mb-6">
                You will no longer receive reminder notifications for <strong>{result?.candidate_name}</strong>.
              </p>
              <p className="text-sm text-slate-500 mb-6">
                The candidate remains in your pipeline. You can still review and take action at any time.
              </p>
              <Link to={result?.review_link || '/'}>
                <Button className="w-full">
                  View Candidate
                </Button>
              </Link>
            </>
          )}
          
          {status === 'error' && (
            <>
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <XCircle className="w-8 h-8 text-red-600" />
              </div>
              <h1 className="text-2xl font-bold text-slate-800 mb-2">Link Invalid</h1>
              <p className="text-slate-600 mb-6">{error}</p>
              <p className="text-sm text-slate-500">
                This opt-out link may have already been used or expired. If you need help, please contact support.
              </p>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
